// Copy-to-clipboard behaviour for the promo code component (snippets/promo-code.liquid).
// Styles in promo-code.css. Click handling is delegated, so codes rendered later (theme
// editor re-render, sections loaded on demand) work without re-initialisation.

const COPIED_CLASS = 'is-copied';
const COPIED_STATE_DURATION_MS = 2000;
const RESIZE_DURATION_MS = 400;
const RESIZE_EASING = 'cubic-bezier(0.16, 1, 0.3, 1)';

const resetTimers = new WeakMap();
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Toggles the copied state and animates the button between the widths of its two labels
function setCopied(button, copied) {
  const startWidth = button.offsetWidth;
  button.classList.toggle(COPIED_CLASS, copied);
  const endWidth = button.offsetWidth;

  if (reducedMotion.matches || startWidth === endWidth) {
    return;
  }

  button.animate({ width: [`${startWidth}px`, `${endWidth}px`] }, { duration: RESIZE_DURATION_MS, easing: RESIZE_EASING });
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.promo-code');

  if (!button) {
    return;
  }

  try {
    await navigator.clipboard.writeText(button.dataset.code);
  } catch {
    return;
  }

  // A second click while already copied only extends the confirmation
  if (!button.classList.contains(COPIED_CLASS)) {
    setCopied(button, true);
  }

  clearTimeout(resetTimers.get(button));
  resetTimers.set(button, setTimeout(() => setCopied(button, false), COPIED_STATE_DURATION_MS));
});
